import { AppCustomDialogHelper } from 'general/components/AppDialogCustom';
import KTBSDropdown from 'general/components/OtherKeenComponents/KTBSDropdown';
import { dateFilter, dateFilterOptions, getDateFilterOption } from 'general/components/Others/CustomDateRangePicker';
import AppColors from 'general/constants/AppColors';
import UIHelper from 'general/helpers/UIHelper';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { useEffect, useMemo, useState } from 'react';

DialogDownloadExcelFile.propTypes = {
    filter: PropTypes.object,
    onDownload: PropTypes.func,
    transactionFromKey: PropTypes.string,
    transactionToKey: PropTypes.string,
};

function DialogDownloadExcelFile({ filter, onDownload, transactionFromKey = 'transactionFrom', transactionToKey = 'transactionTo' }) {
    const [loading, setLoading] = useState(false);

    const [selectedCreatedDate, setSelectedCreatedDate] = useState(dateFilter.baMuoiNgayGanNhat ?? '30_NGAY_GAN_NHAT');
    const [selectedTransactionDate, setSelectedTransactionDate] = useState(dateFilter.tatCaThoiGian);

    useEffect(() => {
        setSelectedCreatedDate(dateFilter.baMuoiNgayGanNhat);
        setSelectedTransactionDate(dateFilter.tatCaThoiGian);
    }, []);

    const createdDateName = useMemo(
        () => _.find(dateFilterOptions, (item) => item.value === selectedCreatedDate)?.name,
        [selectedCreatedDate]
    );
    const transactionDateName = useMemo(
        () => _.find(dateFilterOptions, (item) => item.value === selectedTransactionDate)?.name,
        [selectedTransactionDate]
    );

    const handleSubmit = async () => {
        const createdRange = getDateFilterOption(selectedCreatedDate);
        const transactionRange = getDateFilterOption(selectedTransactionDate);

        const params = _.pickBy(
            {
                ..._.omit(filter, ['limit', 'page']),
                dateFilter: selectedCreatedDate,
                from: createdRange?.[0]?.format('YYYY-MM-DD'),
                to: createdRange?.[1]?.format('YYYY-MM-DD'),
                transactionDateFilter: selectedTransactionDate,
                [transactionFromKey]: transactionRange?.[0]?.format('YYYY-MM-DD'),
                [transactionToKey]: transactionRange?.[1]?.format('YYYY-MM-DD'),
                limit: 1000000,
            },
            (value) => value != null && value !== ''
        );

        try {
            setLoading(true);
            await onDownload(params);
        } finally {
            setLoading(false);
        }
    };

    const onCancel = () => {
        AppCustomDialogHelper.hide();
    };

    const buildDropdownButton = (label, value, name, onChange) => (
        <div>
            {UIHelper.buildFormLabel(label, true)}
            <KTBSDropdown
                toggleElement={
                    <button
                        className="btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between"
                        type="button"
                    >
                        <div className="d-flex align-items-center gap-2">
                            <i className="fa-solid fa-calendar-day" style={{ color: '#494968' }} />
                            <span>{name ?? '30 ngày gần nhất'}</span>
                        </div>
                    </button>
                }
                selectedValue={value}
                dropdownMenuItems={dateFilterOptions}
                dropdownMenuClassName="overflow-auto w-100"
                dropdownMenuStyle={{ maxHeight: '30vh' }}
                onChange={onChange}
            />
        </div>
    );

    return (
        <div>
            <div className="row m-0 p-4 gap-0">
                <div className="col-6 pe-2">
                    {buildDropdownButton(
                        'Chọn thời gian tạo',
                        selectedCreatedDate,
                        createdDateName,
                        setSelectedCreatedDate
                    )}
                </div>
                <div className="col-6 ps-2">
                    {buildDropdownButton(
                        'Chọn kỳ giao dịch',
                        selectedTransactionDate,
                        transactionDateName,
                        setSelectedTransactionDate
                    )}
                </div>
            </div>
            {/* footer */}
            <div
                className="d-flex align-items-center justify-content-end gap-3 px-4 py-3"
                style={{ borderTop: `1px solid ${AppColors.gray[200]}` }}
            >
                {UIHelper.buildNegativeButton('Hủy bỏ', onCancel, null)}
                {UIHelper.buildGreenButton('Tải xuống', handleSubmit, null, false, loading)}
            </div>
        </div>
    );
}

export default DialogDownloadExcelFile;
